import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

export const Portal = ({
  targetId,
  children
}: {
  targetId: string
  children: JSX.Element
  replaceContent?: boolean
}) => {
  const [isMounted, setMounted] = useState(false)
  useEffect(() => {
    setMounted(true)
  }, [])

  if (!isMounted) return null

  const target = document.getElementById(targetId)

  if (!target) return null
  target.innerHTML = ''

  return createPortal(children, target)
}
